module.exports = __webpack_public_path__ + "img/9788936456405.b3525352.jpg";